import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Constants } from '@hub/common/Constants';
import { Functions } from '@hub/common/Functions';
import { eActionState, eColumnType, eContactAttachmentType } from '@hub/generated/enums';
import { FilesController, UserController } from '@hub/generated/services';
import { Attachment } from '@hub/models/attachment.model';
import { SubGridItem } from '@hub/models/common/ui/SubGridItem';
import { ConfirmationService } from 'primeng/api';
import { PageLoaderService } from '@hub/services/PageLoader';
import { NotificationService } from '@hub/services/NotificationService';
import { CurrentUserService } from '@hub/services/CurrentUserService';
import { HttpClientService } from '@hub/services/HttpClientService';

@Component({
  selector: "hub-attachment",
  templateUrl: "./attachment.component.html",
  styles: []
})
export class AttachmentComponent implements OnInit {
  constructor(
    protected pageLoaderService: PageLoaderService,
    protected confirmationService: ConfirmationService,
    protected notificationService: NotificationService,
    protected currentUser: CurrentUserService,
    protected userController: UserController,
    protected httpService: HttpClientService,
    protected filesController: FilesController
  ) {}

  display: boolean = false;
  isNew: boolean = true;
  selection: Attachment[] = [];
  columnDetails: SubGridItem[] = [];
  @Input() data: Attachment[] = [];
  @Input() contactId;
  @Input() deleteMessage: string = '';
  @Input() attachmentTypeEnum: any;
  @Output() getAttachmentsEmitter: EventEmitter<string> = new EventEmitter();
  @Output() removeAttachmentsEmitter: EventEmitter<string> = new EventEmitter();
  @Output() updateAttachmentEmitter: EventEmitter<Attachment> = new EventEmitter();
  @Output() notificationEmitter: EventEmitter<string> = new EventEmitter();

  ngOnInit() {
    this.pageLoaderService.showPageLoader();

    this.columnDetails = [
      {
        Field: "Name",
        Header: "Name",
        ColumnType: eColumnType.PlainText
      },
      {
        Field: "User",
        Header: "User",
        ColumnType: eColumnType.PlainText
      },
      {
        Field: "Type",
        Header: "Type",
        ColumnType: eColumnType.PlainText
      },
      {
        Field: "Date",
        Header: "Date",
        ColumnType: eColumnType.Date
      },
      {
        Field: "Description",
        Header: "Description",
        ColumnType: eColumnType.PlainText
      }
    ];

    this.getData();
  }

  edit() {
    this.display = true;
    this.isNew = false;
  }

  notificationHandler(event) {
    this.notificationEmitter.emit(event);
  }

  displayChangeHandler(event) {
    if (!!!event) {
      this.display = event;
      this.selection = [];
    }
  }

  create() {
    const newAttachment: any = {
      ActionState: eActionState.Inserted,
      Id: Constants.GUID_EMPTY,
      ContactId: this.contactId,
      Name: '',
      Type: eContactAttachmentType.Document,
      Description: '',
      Date: null,
      FileId: '',
      CreatedOn: new Date(),
      CreatedById: Constants.GUID_EMPTY
    };

    this.selection.push(newAttachment);

    this.display = true;
    this.isNew = true;
  }

  updateAttachmentHandler(event: Attachment) {
    this.updateAttachmentEmitter.emit(event);
  }

  public download() {
    for (const attachment of this.selection) {
      this.filesController.GetPublicFileUrlById(attachment.FileId)
      .subscribe(
        result => {
          window.open(result.Path);
        },
        err => {
          this.notificationEmitter.emit('downloadError');
        }
      );
    }
  }

  delete() {
    this.confirmationService.confirm({
      key: "common",
      message: Functions.getDeleteMessageWithNumber(
        this.selection.length,
        this.deleteMessage
      ),
      accept: data => {
        this.deleteSelectedItem();
      }
    });
  }

  onSelect(event: any) {
    this.selection = event;
  }

  onSaveHandler(event) {
    this.selection = [];
    this.pageLoaderService.showPageLoader();
    this.getData();
  }

  protected deleteSelectedItem() {
    for (const attachment of this.selection) {
      this.removeAttachmentsEmitter.emit(attachment.AssocId || attachment.Id);
      this.pageLoaderService.addPageLoader();
    }

    this.selection = [];
  }

  protected getData() {
    this.getAttachmentsEmitter.emit(this.contactId);
    this.selection = [];
  }
}
